export const environment = {
  production: true,
  name: "PRODUCTION"
};
